import React, { useRef } from 'react';
import { Button, Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const arrowBaseStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  zIndex: 5,
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(17, 24, 39, 0.78)',
  color: '#fff',
  border: 'none',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.28)'
};

const DeliveryImageCarousel = ({ images = [], maxHeight = 300 }) => {
  const carouselRef = useRef(null);
  const hasMultipleImages = images.length > 1;

  if (!images.length) {
    return null;
  }

  return (
    <div style={{ position: 'relative' }}>
      {hasMultipleImages && (
        <Button
          type="text"
          aria-label="Previous delivery image"
          icon={<LeftOutlined />}
          onClick={() => carouselRef.current?.prev()}
          style={{ ...arrowBaseStyle, left: 8 }}
        />
      )}

      <Carousel ref={carouselRef} autoplay={hasMultipleImages} dots={hasMultipleImages}>
        {images.map((img, idx) => (
          <div key={`${img.url}-${idx}`} className="text-center">
            <img
              src={img.url}
              alt={img.label}
              style={{ maxHeight, maxWidth: '100%', margin: '0 auto', objectFit: 'contain' }}
            />
            <p className="text-sm text-gray-500 mt-2">{img.label}</p>
          </div>
        ))}
      </Carousel>

      {hasMultipleImages && (
        <Button
          type="text"
          aria-label="Next delivery image"
          icon={<RightOutlined />}
          onClick={() => carouselRef.current?.next()}
          style={{ ...arrowBaseStyle, right: 8 }}
        />
      )}
    </div>
  );
};

export default DeliveryImageCarousel;
